import React, { useEffect } from 'react';
import { StyledContactStepsIndicator } from './StyledContactStepsIndicator';

const ContactStepsIndicator = ({ index, gotoIndex }) => {

  useEffect(() => {
    const circles = document.querySelectorAll('.circle-step');

    for(var i = 0; i < circles.length; i++){
      
      if(i > index){
        
        if(circles[i].classList.contains('selected')){
          circles[i].classList.remove('selected');
        }
          
      }else{
        circles[index].classList.add('selected');
      }
      
    }

  },[index]);

  return (
    <React.Fragment>
      {
       
        <StyledContactStepsIndicator>
          <div className="indicator--wrap">
            <div className="indicator--bar"></div>
            <div className="indicator--bar-green" style={{width: `${index * 16.66}%`}}></div>
            <div className="indicator--current" style={{left: `${index * 16.66}%`}}>
              <div className="indicator--current-hole">
              </div>
            </div>
            <div className="indicator--steps">
              <div className="circle-step" onClick={ () => gotoIndex(0)}></div>
              <div className="circle-step" onClick={ () => gotoIndex(1)}></div>
              <div className="circle-step" onClick={ () => gotoIndex(2)}></div>
              <div className="circle-step" onClick={ () => gotoIndex(3)}></div>
              <div className="circle-step" onClick={() => gotoIndex(4)}></div>
              <div className="circle-step" onClick={() => gotoIndex(5)}></div>
              <div className="circle-step" ></div>
            </div>

          </div>
          
        </StyledContactStepsIndicator>
          
      }
    </React.Fragment>
  );
};


export default ContactStepsIndicator;
